'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var qs = require('query-string');
var reactRouterDom = require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var qs__default = /*#__PURE__*/_interopDefaultLegacy(qs);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useLocation() {
  var location = reactRouterDom.useLocation();

  return _objectSpread({}, location, {
    query: qs__default["default"].parse(location.search)
  });
}
function useRouter() {
  var location = useLocation();
  var history = reactRouterDom.useHistory();
  var params = reactRouterDom.useParams();
  var routeMatch = reactRouterDom.useRouteMatch();
  return {
    location: location,
    history: history,
    navigate: history.push,
    params: params,
    routeMatch: routeMatch
  };
} // @ts-expect-error TS(7006): Parameter 'Component' implicitly has an 'any' type... Remove this comment to see the full error message

function withRouter(Component) {
  // @ts-expect-error TS(7006): Parameter 'props' implicitly has an 'any' type.
  return function (props) {
    var router = useRouter();
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({}, props, router));
  };
}

Object.defineProperty(exports, 'Link', {
  enumerable: true,
  get: function () { return reactRouterDom.Link; }
});
Object.defineProperty(exports, 'MemoryRouter', {
  enumerable: true,
  get: function () { return reactRouterDom.MemoryRouter; }
});
Object.defineProperty(exports, 'Prompt', {
  enumerable: true,
  get: function () { return reactRouterDom.Prompt; }
});
Object.defineProperty(exports, 'Redirect', {
  enumerable: true,
  get: function () { return reactRouterDom.Redirect; }
});
Object.defineProperty(exports, 'Route', {
  enumerable: true,
  get: function () { return reactRouterDom.Route; }
});
Object.defineProperty(exports, 'Router', {
  enumerable: true,
  get: function () { return reactRouterDom.Router; }
});
Object.defineProperty(exports, 'StaticRouter', {
  enumerable: true,
  get: function () { return reactRouterDom.StaticRouter; }
});
Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function () { return reactRouterDom.Switch; }
});
Object.defineProperty(exports, 'generatePath', {
  enumerable: true,
  get: function () { return reactRouterDom.generatePath; }
});
Object.defineProperty(exports, 'matchPath', {
  enumerable: true,
  get: function () { return reactRouterDom.matchPath; }
});
Object.defineProperty(exports, 'useHistory', {
  enumerable: true,
  get: function () { return reactRouterDom.useHistory; }
});
Object.defineProperty(exports, 'useParams', {
  enumerable: true,
  get: function () { return reactRouterDom.useParams; }
});
Object.defineProperty(exports, 'useRouteMatch', {
  enumerable: true,
  get: function () { return reactRouterDom.useRouteMatch; }
});
exports.useLocation = useLocation;
exports.useRouter = useRouter;
exports.withRouter = withRouter;
